import React, { useState } from 'react';
import './../../css/manageskill.css';
import Sidebar from './../../components/sidebar'; // Import Sidebar component

const Profile = () => {
  const [showDetails, setShowDetails] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);

  const profileData = {
    name: 'John Doe',
    description: 'Experienced software developer specializing in Flutter and Dart.',
    proficiencyLevel: 5,
    dateAcquired: '2024-12-27T17:39:25.313Z',
    category: 'Development',
    profilePicture: 'https://via.placeholder.com/150', // Replace with actual image URL
    skillImage: 'https://via.placeholder.com/200', // Replace with the skill image URL
    isCertified: true,
    userId: 'user123',
  };

  const profiles = new Array(5).fill(profileData); // Create an array with 5 duplicate profiles

  const handleClick = (profile) => {
    setSelectedProfile(profile);
    setShowDetails(true);
  };

  const handleClose = () => {
    setShowDetails(false);
    setSelectedProfile(null);
  };

  return (
    <div className="profile-page">
      {/* Sidebar Section */}
      <Sidebar />

      {/* Main Content Section */}
      <div className="profile-container">
        {profiles.map((profile, index) => (
          <div key={index} className="profile-card">
            <div className="profile-header">
              <img 
                src={profile.profilePicture} 
                alt="Profile" 
                className="profile-image" 
              />
            </div>
            <div className="profile-body">
              <h2 className="profile-name">{profile.name}</h2>
              <p className="profile-category">{profile.category}</p>
              <button className="view-details-btn" onClick={() => handleClick(profile)}>
                View Details
              </button>
            </div>
          </div>
        ))}

        {/* Pop-out Profile Details */}
        {showDetails && selectedProfile && (
          <div className="profile-details-popup">
            <div className="popup-content">
              <button className="close-popup" onClick={handleClose}>X</button>
              <h2 className="profile-name">{selectedProfile.name}</h2>
              <p className="profile-description">{selectedProfile.description}</p>
              <div className="profile-detail">
                <strong>Proficiency Level:</strong>
                <span>{selectedProfile.proficiencyLevel}</span>
              </div>
              <div className="profile-detail">
                <strong>Date Acquired:</strong>
                <span>{new Date(selectedProfile.dateAcquired).toLocaleDateString()}</span>
              </div>
              <div className="profile-detail">
                <strong>Certified:</strong>
                <span className={`certified-status ${selectedProfile.isCertified ? 'certified' : 'not-certified'}`}>
                  {selectedProfile.isCertified ? 'Yes' : 'No'}
                </span>
              </div>
              <div className="profile-detail">
                <strong>User ID:</strong>
                <span>{selectedProfile.userId}</span>
              </div>
              {/* Skill Image Section */}
              <div className="skill-image-section">
                <h3>Skill Image</h3>
                <img 
                  src={selectedProfile.skillImage} 
                  alt="Skill" 
                  className="skill-image" 
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Profile;
